import { CreditsInput, InstructionLanguageInput, NationalityInput } from "./Partials";

const ThesisFields = () => (
  <>
    <NationalityInput />
    <InstructionLanguageInput />
    <CreditsInput md={12} />
  </>
);

export default ThesisFields;
